import { Flex } from '@uhg-abyss/web/ui/Flex';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { useTranslation } from 'react-i18next';

type Props = {
  value: string;
  onChange: (searchTerm: string) => void;
};

export const FilterSearchInput = ({ value, onChange }: Props) => {
  const { t } = useTranslation();
  const placeholder = t('CONTENT_FILTERS.FILTER_SEARCH_PLACEHOLDER');

  return (
    <Flex
      css={{
        'abyss-flex-root': {
          position: 'relative',
          overflow: 'visible',
        },
      }}
      direction="column"
    >
      <TextInput
        css={{
          'abyss-form-input-wrapper-container': {
            padding: '4px',
          },
        }}
        data-auto-testid="filter-search-input"
        data-testid="filter-search-input"
        hideLabel
        isClearable
        label={placeholder}
        onChange={(e) => onChange(e.target.value)}
        onClear={() => onChange('')}
        placeholder={placeholder}
        rightAddOn={
          <IconSymbol
            color="$core.color.neutral.60"
            css={{ cursor: 'pointer' }}
            icon="search"
            size="18px"
          />
        }
        value={value}
      />
    </Flex>
  );
};
